import * as React from 'react';
import './Canvas.css';
import { IconButton, Fade, List, ListItem, ListItemText, Dialog, ListItemIcon, Select, MenuItem, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { Add, CheckBoxOutlineBlank, CheckBox, Clear } from '@material-ui/icons';
import CanvasItemForm from './CanvasItemForm';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Guid } from "guid-typescript";
import moment from 'moment';
import Loading from '../Loading';
import { _PortalState } from 'src/helpers/state';

let EditingSection: string;
let EditingItem: CanvasItem | undefined;

class Canvas extends React.Component<{}, ICanvaState> {

  constructor(props: {}) {
    super(props);

    this.state = {
      Loading: true,
      DialogOpen: false,
      DialogOpenError: false,
      HistoryItemSelected: 'Current'
    }
  }

  public componentDidMount() {
    this.loadcanvas(this.props['match'].params.group);
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.group !== this.props['match'].params.group) {
      const id = nextProps.match.params.id
      this.loadcanvas(id);
    }
  }

  private loadcanvas = (groupid) => {
    this.setState({ Loading: true }, () => {
      _PortalState.authProvider.getAccessToken().then(token => {
        // fetch('https://bwventuresportal-api.azurewebsites.net/api/canvas?group=' + this.props['match'].params.group
        fetch(_PortalState.ApiEndpoint + '/api/canvas?group=' + this.props['match'].params.group
          + (this.state.HistoryItemSelected !== 'Current' ? "&date=" + moment(this.state.HistoryItemSelected).format('DD-MM-YYYY') : "")
          , {
            method: 'GET',
            headers: {
              'Authorization': 'Bearer ' + token.accessToken
            }
          })
          .then(res => res.json())
          .then(canvas => {
            if (!canvas.Board) {
              canvas.Board = {
                GroupId: canvas.GroupId
              };
            }
            this.setState({ Loading: false, Canvas: canvas });
          })


        fetch(_PortalState.ApiEndpoint + '/api/canvashistory?group=' + this.props['match'].params.group, {
          method: 'GET',
          headers: {
            'Authorization': 'Bearer ' + token.accessToken
          }
        })
          .then(res => res.json())
          .then(history => {
            const h: any[] = [];
            let f: boolean = true;
            history.Dates.map(d => {
              h.push(
                <MenuItem key={d} value={f ? 'Current' : d}>{f ? 'Current version' : moment(d).format('dddd MMMM Do YYYY')}</MenuItem>
              );
              f = false;
            })
            this.setState({ History: h });
          })
      });
    })
  }

  public render() {
    if (this.state.Loading) {
      return (
        <div>
          <Loading />
        </div>
      );
    }
    else if (!this.state.Loading && this.state.Canvas) {
      return (
        <div>
          <Dialog
            fullWidth={true}
            maxWidth="md"
            open={this.state.DialogOpen}
            onClose={this.handleClose}
            ria-labelledby="form-dialog-title"
          >
            <CanvasItemForm
              Section={EditingSection}
              SectionDisplayName={this.getSectionDisplayName(EditingSection)}
              Item={EditingItem}
              onClose={this.handleClose}
              onSave={this.hanldeSave}
            />
          </Dialog>
          <Dialog
            fullWidth={true}
            maxWidth="md"
            open={this.state.DialogOpenError}
            onClose={() => this.setState({ DialogOpenError: false })}
            ria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Uh oh
              {/* {this.props.Id} */}
            </DialogTitle>
            <DialogContent>
              You can only edit the current version of the canvas.
            </DialogContent>
            <DialogActions>

              <Button
                onClick={() => {
                  this.setState({ HistoryItemSelected: 'Current', DialogOpenError: false }, () => {
                    this.loadcanvas(this.props['match'].params.group)
                  })
                }}
                color="primary"
              >
                Switch to current version
              </Button>

              <Button onClick={() => this.setState({ DialogOpenError: false })} color="primary">
                Close
              </Button>

            </DialogActions>
          </Dialog>
          <Fade in={!this.state.Loading}>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <div>
                <div style={{ display: 'flex', position: 'absolute', width: '96%', left: '0', margin: '10px 0 0 40px', minWidth: '800px' }}>
                  <div style={{ fontSize: '25px' }}>
                    {this.state.Canvas['GroupName']}
                  </div>
                  <div style={{ marginLeft: '20px', marginRight: '22px', paddingTop: '12px' }}>
                    {this.state.Canvas['Groupdescription']}
                  </div>

                  <div style={{ marginLeft: 'auto', marginRight: '15px', paddingTop: '10px' }}>
                    <Select
                      value={this.state.HistoryItemSelected ? this.state.HistoryItemSelected : 'Current'}
                      onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
                        this.setState({ HistoryItemSelected: event.target.value }, () => {
                          this.loadcanvas(this.props['match'].params.group);
                        });
                      }}
                      inputProps={{
                        name: 'History',
                        id: 'History',
                      }}
                    >
                      {this.state.History}
                    </Select>
                  </div>
                </div>
                <div id="canvas">

                  {/* Problem */}
                  <div id="canvas-problem" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">Problem</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "Problem"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"Problem"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.Problem ? this.state.Canvas.Board.Problem.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }

                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "Problem"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* Existing alternatives */}
                  <div id="canvas-existing-alternatives" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">Existing alternatives</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "existingalternatives"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"existingalternatives"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.ExistingAlternatives ? this.state.Canvas.Board.ExistingAlternatives.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "existingalternatives"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>


                  {/* Solution */}
                  <div id="canvas-solution" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">Solution</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "Solution"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"Solution"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.Solution ? this.state.Canvas.Board.Solution.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "Solution"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* Key Metrics */}
                  <div id="canvas-key-metrics" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">Key Metrics</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "keymetrics"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"keymetrics"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.KeyMetrics ? this.state.Canvas.Board.KeyMetrics.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "keymetrics"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* high level concepts */}
                  <div id="canvas-high-level-concepts" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">High level concepts</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "highlevelconcepts"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"highlevelconcepts"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.HighLevelConcepts ? this.state.Canvas.Board.HighLevelConcepts.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "highlevelconcepts"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* Value Proposition */}
                  <div id="canvas-value-proposition" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">unique value proposition</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "uniquevaluepropositions"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"uniquevaluepropositions"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.UniqueValueProposition ? this.state.Canvas.Board.UniqueValueProposition.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "uniquevaluepropositions"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* Unfair Advantage */}
                  <div id="canvas-unfair-advantage" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">unfair advantage</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "unfairadvantage"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"unfairadvantage"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.UnfairAdvantage ? this.state.Canvas.Board.UnfairAdvantage.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "unfairadvantage"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* Channels */}
                  <div id="canvas-channels" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">channels</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "channels"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"channels"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.Channels ? this.state.Canvas.Board.Channels.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "channels"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* Customer segments */}
                  <div id="canvas-customer-segments" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">customer segments</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "customersegments"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"customersegments"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.CustomerSegments ? this.state.Canvas.Board.CustomerSegments.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "customersegments"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* Earlyvangelist */}
                  <div id="canvas-earlyvangalist" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">Earlyvangelist</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "earlyvangalist"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"earlyvangalist"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.Earlyvengalist ? this.state.Canvas.Board.Earlyvengalist.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "earlyvangalist"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* Cost ifra */}
                  <div id="canvas-cost-structure" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">Cost structure</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "coststructure"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"coststructure"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.CostStructure ? this.state.Canvas.Board.CostStructure.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "coststructure"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>

                  {/* Revenue streams */}
                  <div id="canvas-revenue-streams" className="segment">
                    <div>
                      <div className="segment-header-container">
                        <div className="segment-header">revenue stream</div>
                        <div>
                          <IconButton onClick={() => { EditingSection = "revenuestream"; EditingItem = undefined; this.setState({ DialogOpen: true }) }} >
                            <Add />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <List>
                      <Droppable droppableId={"revenuestream"}>
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef}>
                            {this.state.Canvas && this.state.Canvas.Board.RevenueStream ? this.state.Canvas.Board.RevenueStream.map((value, index) => (
                              <Draggable draggableId={value.Id} index={index} key={value.Title}>
                                {(provided2, snapshot2) => (
                                  <div ref={provided2.innerRef}{...provided2.draggableProps}{...provided2.dragHandleProps}>
                                    <ListItem role={undefined} dense={true} button={true}>
                                      {
                                        value.Status === 0 &&
                                        <ListItemIcon>
                                          <CheckBoxOutlineBlank />
                                        </ListItemIcon>
                                      }
                                      {value.Status === 1 &&
                                        <ListItemIcon>
                                          <CheckBox />
                                        </ListItemIcon>
                                      }
                                      {
                                        value.Status === 2 &&
                                        <ListItemIcon>
                                          <Clear />
                                        </ListItemIcon>
                                      }
                                      <ListItemText primary={value.Title} onClick={() => { EditingSection = "revenuestream"; EditingItem = value; this.setState({ DialogOpen: true }) }} />
                                    </ListItem>
                                  </div>
                                )}
                              </Draggable>
                            )) : ""
                            }
                          </div>
                        )}
                      </Droppable>
                    </List>
                  </div>
                </div>
              </div>
            </DragDropContext>
          </Fade>
        </div>
      );
    }
    else {
      return <div />
    }
  }

  private onDragEnd = (result: any) => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }

    if (this.state.Canvas) {
      const canvas: CanvasClass = this.state.Canvas;
      // inside same list
      if (source.droppableId === destination.droppableId) {
        const cursection: CanvasItem[] = this.getSection(canvas, source.droppableId);
        // console.log(cursection);
        // remove item from current index
        const i: CanvasItem = cursection[source.index];
        cursection.splice(source.index, 1);
        cursection.splice(destination.index, 0, i);
        this.save(canvas);
      } else {
        const destSection: CanvasItem[] = this.getSection(canvas, destination.droppableId);
        const sourceSection: CanvasItem[] = this.getSection(canvas, source.droppableId);
        const i: CanvasItem = sourceSection[source.index];
        // remove
        sourceSection.splice(source.index, 1);
        // add
        destSection.splice(destination.index, 0, i);
        this.save(canvas);
      }
    }

  }

  private getSection = (canvas: CanvasClass, section: string) => {
    let cursection: CanvasItem[] = [];
    switch (section.toLowerCase()) {
      case "problem":
        if (!canvas.Board.Problem) {
          canvas.Board.Problem = [];
        }
        cursection = canvas.Board.Problem;
        break;

      case "existingalternatives":
        if (!canvas.Board.ExistingAlternatives) {
          canvas.Board.ExistingAlternatives = [];
        }
        cursection = canvas.Board.ExistingAlternatives;
        break;
      case "solution":
        if (!canvas.Board.Solution) {
          canvas.Board.Solution = [];
        }
        cursection = canvas.Board.Solution;
        break;
      case "keymetrics":
        if (!canvas.Board.KeyMetrics) {
          canvas.Board.KeyMetrics = [];
        }
        cursection = canvas.Board.KeyMetrics;
        break;
      case "uniquevaluepropositions":
        if (!canvas.Board.UniqueValueProposition) {
          canvas.Board.UniqueValueProposition = [];
        }
        cursection = canvas.Board.UniqueValueProposition;
        break;
      case "highlevelconcepts":
        if (!canvas.Board.HighLevelConcepts) {
          canvas.Board.HighLevelConcepts = [];
        }
        cursection = canvas.Board.HighLevelConcepts;
        break;
      case "unfairadvantage":
        if (!canvas.Board.UnfairAdvantage) {
          canvas.Board.UnfairAdvantage = [];
        }
        cursection = canvas.Board.UnfairAdvantage;
        break;
      case "channels":
        if (!canvas.Board.Channels) {
          canvas.Board.Channels = [];
        }
        cursection = canvas.Board.Channels;
        break;
      case "customersegments":
        if (!canvas.Board.CustomerSegments) {
          canvas.Board.CustomerSegments = [];
        }
        cursection = canvas.Board.CustomerSegments;
        break;
      case "earlyvangalist":
        if (!canvas.Board.Earlyvengalist) {
          canvas.Board.Earlyvengalist = [];
        }
        cursection = canvas.Board.Earlyvengalist;
        break;
      case "coststructure":
        if (!canvas.Board.CostStructure) {
          canvas.Board.CostStructure = [];
        }
        cursection = canvas.Board.CostStructure;
        break;
      case "revenuestream":
        if (!canvas.Board.RevenueStream) {
          canvas.Board.RevenueStream = [];
        }
        cursection = canvas.Board.RevenueStream;
        break;
      default:
        break;
    }
    return cursection;
  }

  private getSectionDisplayName = (section: string) => {
    if (section === undefined) {
      return "";
    }
    switch (section.toLowerCase()) {
      case "problem":
        return "problem"
      case "existingalternatives":
        return "existing alternatives"
      case "solution":
        return "solution"
      case "keymetrics":
        return "key metric"
      case "uniquevaluepropositions":
        return "unique value proposition"
      case "highlevelconcepts":
        return "high level concepts"
      case "unfairadvantage":
        return "unfair advantage"
      case "channels":
        return "channel"
      case "customersegments":
        return "customer segment"
      case "earlyvangalist":
        return "earlyvangalist";
      case "coststructure":
        return "cost structure"
      case "revenuestream":
        return "revenue stream"
      default:
        break;
    }
    return "";
  }

  private save = (canvas: CanvasClass) => {
    if (this.state.HistoryItemSelected !== 'Current') {
      this.setState({ DialogOpenError: true }, () => {
        this.loadcanvas(this.props['match'].params.group);
      })
      return;
    }
    _PortalState.authProvider.getAccessToken().then(token => {
      fetch(_PortalState.ApiEndpoint + '/api/canvas', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token.accessToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(canvas.Board)
      }).then(() => {
        this.setState({ Canvas: canvas, DialogOpen: false });
      })
        .catch((err) => {
          console.log(err);
        })
    })
  }

  private handleClose = () => {
    this.setState({ DialogOpen: false });
  }

  private hanldeSave = (section: string, item: CanvasItem) => {
    if (this.state.Canvas) {
      const canvas: CanvasClass = this.state.Canvas;
      const cursection: CanvasItem[] = this.getSection(canvas, section.toLowerCase());

      if (item.Id && cursection.some(c => c.Id === item.Id)) {
        const value = cursection.find(c => c.Id === item.Id);
        if (value && item.Title.length > 0) {
          value.Title = item.Title;
          value.Status = item.Status;
          if (value.Id === null) {
            value.Id = Guid.create().toString();
          }
        } else if (value && item.Title.length === 0) {
          cursection.splice(cursection.findIndex(c => c.Id === item.Id), 1);
        }
      }
      else {
        cursection.push(
          {
            Title: item.Title,
            Status: item.Status,
            Id: Guid.create().toString()
          }
        );
      }
      this.save(canvas);
    }
    this.handleClose();
  }
}

export default Canvas;

interface ICanvaState {
  Loading: boolean;
  Canvas?: CanvasClass;

  History?: any[];
  HistoryItemSelected: any;

  DialogOpen: boolean;
  DialogOpenError: boolean;
}

class CanvasClass {
  public GroupId: string;
  public GroupName: string;
  public Groupdescription?: string;
  public Board: Board;
}

class Board {
  public GroupId: string;
  public Version: number;
  public Problem: CanvasItem[];
  public ExistingAlternatives: CanvasItem[];
  public Solution: CanvasItem[];
  public KeyMetrics: CanvasItem[];
  public UniqueValueProposition: CanvasItem[];
  public HighLevelConcepts: CanvasItem[];
  public UnfairAdvantage: CanvasItem[];
  public Channels: CanvasItem[];
  public CustomerSegments: CanvasItem[];
  public Earlyvengalist: CanvasItem[];
  public CostStructure: CanvasItem[];
  public RevenueStream: CanvasItem[];
}

export class CanvasItem {
  public Id: string;
  public Status: number;
  public Title: string;
  // public Comments?: string;
}



// WEBPACK FOOTER //
// ./src/components/canvas/Canvas.tsx